//console.log('hello, its me!');
(function($) {
    $(document).ready(function() {
        $('ul.tabs li').click(function(){
            var tab_id = $(this).attr('data-tab');

            $('ul.tabs li').removeClass('current');
            $('.tab-content').removeClass('current');

            $(this).addClass('current');
            $("#"+tab_id).addClass('current');
        });



         //$("#tab-archive .newsList:not(:first)").hide();
        // $("#newsContent .current").show();
        paginateCustom();
        var dataYear = $(".tab-link").attr('data-year');
        var datatarget = $(".tab-link").attr('data-target');
        if($('.newslist__date[data-date*='+dataYear+']').length > 0){
            $('.newslist__date[data-date*='+dataYear+']').closest('.news-item').show();
            $("#newsContent  p.noresults").hide();
            $(".pagination").show();
        } else {
            $(".news-item").hide();
            $(".pagination").hide();
        }
        $(".tab-link").click(function () {

            var dataYear = $(this).attr('data-year');
            var datatarget = $(this).attr('data-target');
            $(".news-item").hide();
            $(".pagination").hide();
            if($('.newslist__date[data-date*='+dataYear+']').length > 0){
                    $('.newslist__date[data-date*='+dataYear+']').closest('.news-item').show();
                    $("#newsContent  p.noresults").hide();
                    $(".pagination").show();
            }
            else  if(dataYear=="Archive"){
                var previousYear = (new Date).getFullYear() - 1;
                //console.log(previousYear);
                $('.newslist__date[data-date*='+previousYear+']').closest('.news-item').show();
                $('.newslist__date[data-date*="2017"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2016"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2015"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2014"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2013"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2012"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2011"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2010"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2009"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2008"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2007"]').closest('.news-item').show();
                $('.newslist__date[data-date*="2006"]').closest('.news-item').show();
            }
           else{
                $("p.noresults").show();
                $(".pagination").hide();
            }
           paginateCustom();
            $('.tab').hide();
            $(".tab[data-element="+datatarget+"]").show();
            $(".tabnav__link").removeClass('active');
            $(this).addClass('active');


        });
        $('body').on('click', '.tab-link', function() {
            if($('#tab-archive').find('.news-item').length !== 0){
                $(".pagination").show();
            } else {
                $(".pagination").hide();
            }
        });
    });
})(jQuery);

function paginateCustom() {
    $(".pagination").html('');
    if($(".news-item").parent(".paginatined").length){
        $(".paginatined .news-item").unwrap();
    }

    var divs = $(".news-item:visible");
    var nthValue =0
    for(var i = 0 ; i < divs.length; i+=10) {
        nthValue = nthValue+1;
        divs.slice(i, i+10).wrapAll("<div class='paginatined' id='page-"+nthValue+"'></div>");
    }
    var paginatedLenght = $(".paginatined").length;
    $(".paginatined").hide();
    $(".paginatined").first().show();
    for (var i = 0; i < paginatedLenght; i++){
         // if(paginatedLenght > 10){
         //     if((i < paginatedLenght -4) && (i > 4 ) ){
         //         $(".pagination").append('<span class="page hidden-item num" data-target="page-'+(i+1)+'">'+(i+1) +'</span>');
         //     }
         //     else{
         //         $(".pagination").append('<span class="page shown-item num" data-target="page-'+(i+1)+'">'+(i+1) +'</span>');
         //     }
         // }
         // else{
             $(".pagination").append('<span class="page num shown-item" data-target="page-'+(i+1)+'">'+(i+1) +'</span>');
         // }

    }
    $(".pagination").prepend('<span class="page prev"><</span>');
    $(".pagination").append('<span class="page next">></span>');
    // $(".page.hidden-item").last().after('<span class="page dot">...</span>');
    $("span.page.num").first().addClass('active');

    $(document).on('click','span.page.num',function (e) {
        console.log("clickyo Aavo");
        e.stopPropagation();

        $("span.page").removeClass('active');
        $(this).addClass('active');
        var targetPage =$(this).attr('data-target');
        $(".paginatined").hide();
        $(".paginatined#"+targetPage).show();
    });
    $(document).on('click','span.page.prev',function () {
        var elementTrigger = $("span.page.active").prevAll('.num.shown-item').first();
        if(elementTrigger.length > 0){
            clickActive(elementTrigger);
        }
        console.log("I am called"+elem);
        // if($("span.page.active").prev('.hidden-item').length >0){
        //     $("span.page.active").prev('.hidden-item').addClass('shown-item').removeClass('hidden-item');
        //     $("span.page.dot").prevAll(".shown-item").first().addClass('hidden-item').removeClass('shown-item');
        // }
        // if($("span.page.active").prev('.dot').length >0){
        //     $("span.page.active").prevAll('.num.shown-item').first().click();
        //     $('.dot').prevAll('.num.hidden-tem').addClass('shown-item').removeClass('hidden-item');
        // }
        // $('.dot').removeClass('hidden-item');
    });
    $(document).on('click','span.page.next',function () {
        var elementTrigger =  $("span.page.active").nextAll('.num.shown-item').first();
        if(elementTrigger.length > 0){
            clickActive(elementTrigger);
        }

        console.log("I am called"+elem);
        // if($("span.page.active").next('.hidden-item').length >0){
        //     $("span.page.active").next('.hidden-item').addClass('shown-item').removeClass('hidden-item');
        //     $("span.page.num.shown-item").first().addClass('hidden-item').removeClass('shown-item');
        //
        // }
        // if($("span.page.active").nextAll('.hidden-item').length <1){
        //     $('.dot').addClass('hidden-item');
        // }
    });

    $('[data-target="page-11"]').click(function () {
        $("html,body").scrollTop($(".content-box").offset().top -100);
    })
    function existHide() {
        if($(".num.hidden-item").length > 0){
            $('.dot').removeClass('hidden-item');
        }
        else{
            $('.dot').addClass('hidden-item');
        }
    }
}

function clickActive(elem) {

        $("span.page").removeClass('active');
        elem.addClass('active');
        var targetPage =elem.attr('data-target');
        $(".paginatined").hide();
        $(".paginatined#"+targetPage).show();
         elem =null;

}
